import * as React from 'react';
import PropTypes from 'prop-types';

const SvgAchievementsLocalLegendNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#achievements_local_legend_normal_small_svg__clip0_138_561)">
        <path
          d="M6.252 3.268a3.56 3.56 0 01.767-1.203 4.09 4.09 0 012.81-.65 4.18 4.18 0 01-1.1 2.67 3.64 3.64 0 01-1.598.616l-.162.115a7.724 7.724 0 00-1.35 1.221 4.67 4.67 0 01.24-.102 3.81 3.81 0 012.71.48 4.12 4.12 0 01-2.11 1.86 3.83 3.83 0 01-2.129-.184 7.725 7.725 0 00-.616 3.163v.023l-.001.075c.103-.228.225-.447.366-.657a3.82 3.82 0 012.65-1.12 4.5 4.5 0 01-.73 2.91 3.82 3.82 0 01-1.978 1.051 7.525 7.525 0 002.378 3.633 5.23 5.23 0 01-.34-1.684 5.17 5.17 0 011.67-3.22 5.23 5.23 0 011.38 3.36A5.17 5.17 0 018 18.198c.249.119.504.224.766.315 1.144.343 2.225.86 3.204 1.53a11.806 11.806 0 013.258-1.589c.24-.084.473-.18.701-.286a5.17 5.17 0 01-1.06-2.512 5.23 5.23 0 011.38-3.36 5.13 5.13 0 011.69 3.19 5.24 5.24 0 01-.299 1.575 7.518 7.518 0 002.286-3.495 3.79 3.79 0 01-1.917-1.04 4.5 4.5 0 01-.75-2.95c1 .007 1.956.41 2.66 1.12.128.188.24.386.337.59l-.002-.086v-.02a7.725 7.725 0 00-.615-3.083 3.85 3.85 0 01-2.1.178 4.12 4.12 0 01-2.13-1.86 3.85 3.85 0 012.72-.48c.07.028.138.057.206.087a7.716 7.716 0 00-1.364-1.224l-.158-.111a3.639 3.639 0 01-1.514-.602 4.12 4.12 0 01-1.1-2.67 4.09 4.09 0 012.79.65 3.61 3.61 0 01.923 1.747 9.074 9.074 0 011.723 1.661 4.783 4.783 0 01-.016-.828 4.56 4.56 0 011.57-2.62 4.77 4.77 0 01.81 2.99 4.56 4.56 0 01-1.224 2.313c.448.976.72 2.022.802 3.09a4.2 4.2 0 012.372-1.433 4.88 4.88 0 01-.53 3.08 4.25 4.25 0 01-2.09 1.498 8.866 8.866 0 01-1.696 3.375l.096-.022a5 5 0 013.35 1.16 5.16 5.16 0 01-3.02 1.93 5 5 0 01-3.002-.9 8.864 8.864 0 01-1.396.627l-.011.004-.013.004c-.9.276-1.755.673-2.544 1.175.157.139.31.281.46.428l.003.004.609.609-1.252.657-.308-.307-.002-.002a10.174 10.174 0 00-.627-.568c-.199.167-.392.342-.578.524l-.347.36-1.245-.654.634-.657.007-.007c.132-.13.267-.256.405-.379a10.194 10.194 0 00-2.486-1.122l-.014-.004-.014-.005a8.865 8.865 0 01-1.433-.642 5 5 0 01-2.956.855 5.2 5.2 0 01-3.01-1.93 5 5 0 013.34-1.161 8.88 8.88 0 01-1.655-3.37 4.25 4.25 0 01-2.035-1.48 4.88 4.88 0 01-.53-3.08 4.2 4.2 0 012.334 1.39A9.075 9.075 0 013.205 7.3a4.56 4.56 0 01-1.196-2.285 4.79 4.79 0 01.8-2.99 4.56 4.56 0 011.57 2.62c.02.26.017.52-.007.777a9.09 9.09 0 011.727-1.643c.038-.174.09-.344.153-.51z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="achievements_local_legend_normal_small_svg__clip0_138_561">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgAchievementsLocalLegendNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgAchievementsLocalLegendNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgAchievementsLocalLegendNormalSmall;
